module.exports = __webpack_public_path__ + "static/media/55942629_2519308344811008_1615094306740109312_o.27585906.jpg";